import { Injectable } from '@angular/core';
import type { FilterDigestFindInterface } from '@zaoblako/shared/modules/personalization/dtos/filter-digest/filter-digest-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilterDigestService extends BaseService {
  protected baseUrl = '/basis/personalization/filter-digest';

  public findOne<T = any>(digest: string): Observable<FilterDigestFindInterface<T>> {
    return this.http.get<FilterDigestFindInterface<T>>(`${this.baseUrl}/${digest}`);
  }

  public createOne<T = any>(filter: T): Observable<FilterDigestFindInterface<T>> {
    return this.http.post<FilterDigestFindInterface<T>>(this.baseUrl, filter);
  }

  public updateOne<T = any>(digest: string, filter: T): Observable<FilterDigestFindInterface<T>> {
    return this.http.put<FilterDigestFindInterface<T>>(`${this.baseUrl}/${digest}`, filter);
  }
}
